import React, { Component } from 'react';
import { getAuth0Client } from './auth0Client';
import { hasActiveSession } from './session';
import { DASHBOARD_PERF_MARKS, markDashboardPerformance } from '../utils/dashboardPerformance';
import './Login.css';

class Login extends Component {
    componentDidMount() {
        if (hasActiveSession()) {
            markDashboardPerformance(DASHBOARD_PERF_MARKS.LOGIN_AUTHENTICATED, {
                source: 'existing_session',
            });
            this.props.history.push('/admin/dashboard');
            return;
        }
        getAuth0Client().loginWithRedirect();
    }

    render() {
        return <div className="login-page" style={{ minHeight: '100vh' }} />;
    }
}

export default Login;